import { Box, makeStyles, Typography } from "@material-ui/core"
import React from "react"
import HoverLink from "./HoverLink"
import { fade } from "@material-ui/core/styles/colorManipulator"

const useStyles = makeStyles(theme => ({
  dropdown: {
    position: "relative",
    "&:hover, &:focus": {
      "& $dropdownContent": {
        display: "block",
      },
    },
  },
  dropdownContent: {
    boxShadow: theme.shadows[2],
    padding: theme.spacing(1),
    display: "none",
    position: "absolute",
    zIndex: 1,
    top: "100%",
    backgroundColor: fade(theme.palette.primary.main, 0.7),
  },
}))

export type Link = {
  name: string
  to: string
}
interface DropdownLinkProps {
  name: string
  links: Link[]
}

const DropdownLink = ({ name, links }: DropdownLinkProps) => {
  const classes = useStyles()
  return (
    <Box display="flex" className={classes.dropdown}>
      <HoverLink name={name} variant="h5" />
      <Box className={classes.dropdownContent}>
        {links.map(l => (
          <HoverLink key={l.name} name={l.name} to={l.to} variant="h6" />
        ))}
      </Box>
    </Box>
  )
}

export default DropdownLink
